type ImgsType = Array<FinalImgs>;

interface FinalImgs {
    src: [];
}

interface TheData {
    activeImage: string;
    popUpIsActive: boolean;
    activeIndex: number;
}

import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import template from './right-side-images.vue';

import jQuery from 'jquery';

import Carousel from 'vue-owl-carousel';
import Lightbox from 'vue-simple-lightbox';

@Component({
    mixins: [template],
    components: {
        Carousel,
        Lightbox
    }
})

export default class RightSideImages extends Vue {

    @Prop(Object) readonly auctionData!: any;

    data: TheData = {
        activeImage: '',
        activeIndex: 0,
        popUpIsActive: false
    }

    created() {

    }

    popUpImageOpen(index: any, e: any) {

        e.preventDefault();

        this.data.activeImage   = this.auctionData.lots[this.$store.state.currentShownLot].imagesData[index].full;
        this.data.popUpIsActive = true;
        this.data.activeIndex   = index;

    }

    closePopUp() {

        this.data.popUpIsActive = false;

    }

    popUpGetPrev() {

        this.data.activeImage = this.auctionData.lots[this.$store.state.currentShownLot].imagesData[this.data.activeIndex - 1].full;
        this.data.activeIndex--;

    }

    popUpGetNext() {

        this.data.activeImage = this.auctionData.lots[this.$store.state.currentShownLot].imagesData[this.data.activeIndex + 1].full;
        this.data.activeIndex++;

    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/components/right-side-images/index.ts